import { reportClientError } from "./report-client-error";

let installed = false;

/**
 * Capture async crashes that React's ErrorBoundary cannot see:
 *  - uncaught exceptions on `window`
 *  - unhandled promise rejections
 * Both are deduped + rate-limited by reportClientError itself.
 *
 * Idempotent - safe to call multiple times (HMR, double-mount, etc).
 */
export function installGlobalErrorHandlers(): void {
  if (installed || typeof window === "undefined") return;
  installed = true;

  window.addEventListener("error", (event) => {
    // Ignore ResizeObserver loop warnings (benign noise some browsers emit).
    const msg = event.message || "";
    if (msg.includes("ResizeObserver loop")) return;

    reportClientError({
      scope: "window.onerror",
      message: msg || "Unknown window error",
      stack: event.error?.stack ?? null,
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    const message =
      reason instanceof Error
        ? reason.message
        : typeof reason === "string"
          ? reason
          : (() => {
              try {
                return JSON.stringify(reason);
              } catch {
                return "Unknown unhandled rejection";
              }
            })();

    reportClientError({
      scope: "unhandledrejection",
      message,
      stack: reason instanceof Error ? reason.stack ?? null : null,
    });
  });
}
